<template>
  <Modern :hideTopHorizontal="true" :showRight="showRight">
    <MenuCol slot="MenuSider" />
    <router-view slot="ListItem" />
  </Modern>
</template>
<script>
import Modern from "@/layouts/Modern";
import MenuCol from "./menuCol";

const shortBorder = "1px solid #bebebe";
export default {
  components: { MenuCol, Modern },
  data() {
    return {
      showRight: false,
      idPhieu: "",
    };
  },
  watch: {
    $route(to, from) {
      this.checkRightColumn();
    },
  },
  computed: {
    showMiddleComponent() {
      const path = this.$route.path;
      if (path.indexOf("quy-trinh") > -1) return true;
      return false;
    },
  },
  methods: {
    checkRightColumn() {
      if (this?.$route?.params?.idPhieu) {
        this.showRight = true;
        this.idPhieu = this.$route.params.idPhieu;
      } else {
        this.showRight = false;
        this.idPhieu = "";
      }
    },
  },
  created() {
    this.checkRightColumn();
  },
};
</script>
<style lang="css" scoped></style>
